<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4">
          <div class="card-header pb-0">
            <div class="d-flex justify-content-between flex-wrap">
              <div>
                <div>
                  <h3 class="card-title text-primary mb-0">Destacados</h3>
                  <div class="sub-line"></div>
                </div>
              </div>
              <div class="mt-2">
                  <router-link
                    :to="{ name: 'Crear-Noticia' }"
                    class="
                      btn btn-primary
                      text-white
                      bg-blue-600
                      rounded-lg
                      hover:bg-blue-900
                    "
                  >Añadir Destacado
                  </router-link>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 py-2">
                <el-input
                  clearable
                  type="text"
                  placeholder="Título"
                  v-model="searchTitle"
                />
              </div>
              <div class="col-md-3">
                <el-select v-model="searchProvince" class="m-2" placeholder="Provincia" size="large" clearable>
                  <el-option
                    v-for="item in provinces"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </div>
              <div class="col-md-3 py-2">
                <el-date-picker
                  v-model="searchDate"
                  type="date"
                  value-format="YYYY-MM-DD"
                  placeholder="Fecha"
                  :shortcuts="shortcuts"
                />
              </div>
              <div class="col-md-3">
                <button
                  @click="handleSearch"
                  class="
                      float-start
                      btn btn-primary
                      text-white
                      bg-blue-600
                      rounded-lg
                      border border-primary
                      hover:bg-blue-900
                      mt-2
                    ">
                  Buscar
                </button>
              </div>
            </div>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                <tr>
                  <th class="text-uppercase font-weight-bolder text-custom text-xxs">
                    Titulo
                  </th>
                  <th class="d-none d-lg-table-cell text-uppercase font-weight-bolder text-left">
                    Provincia
                  </th>
                  <th class="d-none d-lg-table-cell text-uppercase font-weight-bolder text-left">
                    Activo
                  </th>
                  <th class="d-none d-lg-table-cell text-uppercase font-weight-bolder text-left">
                    Fecha de Publicación
                  </th>
                  <th class="d-none d-lg-table-cell text-uppercase font-weight-bolder text-left">
                    Fecha de fin de Publicación
                  </th>
                </tr>
                </thead>
                <tbody v-if="posts.length > 0">
                <tr v-for="item in posts" :key="item.id">
                  <td>
                    <div class="d-flex px-2 py-1">
                      <div class="d-flex flex-column justify-content-center">
                        <h6 class="mb-0 text-sm">
                          <router-link :to="{name: 'Detalle-Noticia', params: { id: item.id }}">
                            {{ item.title }}
                          </router-link>
                        </h6>
                      </div>
                    </div>
                  </td>
                  <td class="d-none d-lg-table-cell text-left">
                    <span v-if="item.province"> {{ item.province.name }} </span>
                  </td>
                  <td class="d-none d-lg-table-cell text-left">
                    <i :class="[item.enabled ? 'fa fa-check' : 'fa fa-times']"></i>
                  </td>
                  <td class="d-none d-lg-table-cell text-left">
                    {{ filterDate(item.publishedAt) }}
                  </td>
                  <td class="d-none d-lg-table-cell text-left">
                    {{ filterDate(item.dueDate) }}
                  </td>
                  <td>
                    <div class="text-left">
                      <router-link :to="{
                                              name: 'Actualizar-Noticia',
                                              params: { id: item.id },
                                            }">
                        <a class="btn btn-link text-dark px-3 mb-0" href="javascript:;">
                          <i class="fa fa-pencil text-dark me-2" aria-hidden="true"></i>Editar
                        </a>
                      </router-link>
                      <a
                          class="btn btn-link text-danger text-gradient px-3 mb-0"
                          href="javascript:;"
                          @click="handleDelete(item.id)"
                      >
                        <i class="far fa-trash-alt me-2" aria-hidden="true"></i>Borrar
                      </a>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted, ref} from "vue";
import {useStore} from "vuex";
import {ElMessageBox} from "element-plus";

const store = useStore();
const searchTitle = ref("");
const searchProvince = ref("");
const searchDate = ref("");

const provinces = computed(() => store.state.province.provinces);
const posts = computed(() => {
    return  store.state.post.posts
  });
// const role = computed(() => store.getters["auth/getRole"]);

const getPosts = async () => {
  return await store.dispatch("post/getPosts");
};

const getProvinces = async () => {
  return await store.dispatch("province/getList");
};

onMounted(() => {
  getProvinces();
  getPosts();
});

const deletePost = async (position) => {
  try {
    await store.dispatch("post/deletePost", position);
    await getPosts();
  } catch (error) {
    console.log(error);
  }
};

const handleDelete = (item) => {
  ElMessageBox.confirm("¿Estás seguro que deseas eliminar el registro?")
    .then(() => {
      deletePost(item);
    })
    .catch(() => {
      // catch error
    });
};

const filterDate = (date = null) => {
  if(date){
    return date.split('T')[0]
  }
  return null;
}
const shortcuts = [
  {
    text: 'Hoy',
    value: new Date(),
  }
]

const handleSearch = () => {
  store.dispatch("post/getPosts", {
    title: searchTitle.value,
    'province.id': searchProvince.value,
    publishedAt: searchDate.value,
  });
}

</script>
